(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}

var $4MhCa = parcelRequire("4MhCa");
var $58628397f97bb7cb$var$nav, $58628397f97bb7cb$var$ham, $58628397f97bb7cb$var$close, $58628397f97bb7cb$var$home, $58628397f97bb7cb$var$events, $58628397f97bb7cb$var$ff, $58628397f97bb7cb$var$wheel, $58628397f97bb7cb$var$myspace, $58628397f97bb7cb$var$logout;
var $58628397f97bb7cb$var$init = false;
window.addEventListener("load", ()=>{
    $58628397f97bb7cb$var$nav = document.querySelector("nav");
    $58628397f97bb7cb$var$ham = document.querySelector(".MMFOOD");
    $58628397f97bb7cb$var$close = document.querySelector(".mobile-close");
    $58628397f97bb7cb$var$home = document.querySelector("nav .home");
    $58628397f97bb7cb$var$events = document.querySelector("nav .events");
    $58628397f97bb7cb$var$ff = document.querySelector("nav .funfive");
    $58628397f97bb7cb$var$wheel = document.querySelector("nav .wheel");
    $58628397f97bb7cb$var$myspace = document.querySelector("nav .myspace");
    $58628397f97bb7cb$var$logout = document.querySelector("nav .logout");
    $58628397f97bb7cb$var$ham.addEventListener("click", $58628397f97bb7cb$var$mobileMenu);
    $58628397f97bb7cb$var$close.addEventListener("click", $58628397f97bb7cb$var$mobileMenu);
});
const $58628397f97bb7cb$var$mobileMenu = ()=>{
    $58628397f97bb7cb$var$nav.classList.toggle("mobile-menu");
    if ($58628397f97bb7cb$var$nav.classList.contains("mobile-menu")) {
        if (!$58628397f97bb7cb$var$init) {
            $58628397f97bb7cb$var$init = true;
            $58628397f97bb7cb$var$initFX();
        }
        document.getElementById("webgl").style.display = "block";
        const t = gsap.timeline();
        t.fromTo($58628397f97bb7cb$var$home, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.1);
        t.fromTo($58628397f97bb7cb$var$events, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.125);
        t.fromTo($58628397f97bb7cb$var$ff, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.18);
        t.fromTo($58628397f97bb7cb$var$wheel, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.21);
        t.fromTo($58628397f97bb7cb$var$myspace, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.24);
        t.fromTo($58628397f97bb7cb$var$logout, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5
        }, 0.3);
        t.fromTo($58628397f97bb7cb$var$home, {
            translateY: "75px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.1);
        t.fromTo($58628397f97bb7cb$var$events, {
            translateY: "95px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.125);
        t.fromTo($58628397f97bb7cb$var$ff, {
            translateY: "105px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.18);
        t.fromTo($58628397f97bb7cb$var$wheel, {
            translateY: "115px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.21);
        t.fromTo($58628397f97bb7cb$var$myspace, {
            translateY: "125px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.24);
        t.fromTo($58628397f97bb7cb$var$logout, {
            translateY: "155px"
        }, {
            translateY: "0px",
            duration: 0.75,
            ease: "elastic.out(1, 0.5)"
        }, 0.3);
        t.fromTo($58628397f97bb7cb$var$home, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.1);
        t.fromTo($58628397f97bb7cb$var$events, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.125);
        t.fromTo($58628397f97bb7cb$var$ff, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.18);
        t.fromTo($58628397f97bb7cb$var$wheel, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.21);
        t.fromTo($58628397f97bb7cb$var$myspace, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.24);
        t.fromTo($58628397f97bb7cb$var$logout, {
            scale: 0.25
        }, {
            scale: 1,
            duration: 0.85,
            ease: "elastic.out(1.5, 0.75)"
        }, 0.3);
    } else document.getElementById("webgl").style.display = "none";
};
const $58628397f97bb7cb$var$initFX = ()=>{
    (0, $4MhCa.initializeFX)(document.getElementById("webgl"), null, null, false, "nav");
};

})();
//# sourceMappingURL=events.e10cbd8b.js.map
